import { NgModule } from '@angular/core';
import { QRCodeComponent } from './angularx-qrcode.component';

@NgModule({
  providers: [],
  declarations: [QRCodeComponent],
  exports: [QRCodeComponent],
})
export class QRCodeModule {}
